import React, { JSX } from 'react'
import { Navigate, useLocation } from 'react-router-dom'
import Store from '../store/Store'
import { Loading } from '../components/ui/Loading'

const TWO_FACTOR_PATHS = ['/2fa']

export default function ProtectedRoute({ children }: { children: JSX.Element }) {
	const isLoggedIn = Store.use('isLoggedIn')
	const isLoaded = Store.use('isLoaded')
	const twoFactorRequired = Store.use('twoFactorRequired')
	const twoFactorVerified = Store.use('twoFactorVerified')
	const user = Store.user
	const location = useLocation()

	if (!isLoaded) return <Loading spinner />

	if (!isLoggedIn) {
		return <Navigate to="/login" replace state={{ from: location }} />
	}

	if (
		twoFactorRequired &&
		!twoFactorVerified &&
		!TWO_FACTOR_PATHS.includes(location.pathname)
	) {
		return <Navigate to="/2fa" replace />
	}

	const isUsersPage = location.pathname === '/users'

	const canAccessUsersPage =
		user?.agentType === 'PROVIDER' &&
		user?.roles?.some(
			(r) => r.name === 'ROLE_ADMIN' || r.name === 'ROLE_SUPER_ADMIN'
		)

	if (isUsersPage && !canAccessUsersPage) {
		return <Navigate to="/dashboard" replace />
	}

	// emergency functions only for super admins (the backend enforces the same)
	if (location.pathname === '/emergency' && !Store.isSuperAdmin()) {
		return <Navigate to="/dashboard" replace />
	}

	return children
}
